// extracted by mini-css-extract-plugin
module.exports = {"container":"ChuzhiNoticeList_container__3mKBc","filter":"ChuzhiNoticeList_filter__2Gz8r","list":"ChuzhiNoticeList_list__2Sk91"};